module.exports = __webpack_public_path__ + "fonts/fa-v2-solid-900.727b7753.woff2";